export default __webpack_public_path__ + "static/7-1--c6d1a2e30580327b1cf50b66e13e9243.png";